<template>
  <div>
    <div class="d-flex" style="min-width: 810px">
      <div
        style="width: 280px; min-width: 280px; margin-right: 15px"
        v-loading="loading"
      >
        <PageFilter ref="filter" v-model="tskStatus" @change="filterChange">
          <el-button type="primary" @click="addFormVisible = true">
            {{ $l('btn_addTask') || '新增任务' }}
          </el-button>
        </PageFilter>
      </div>
      <div style="width: calc(100% - 295px); min-width: calc(100% - 295px)">
        <el-card shadow="never">
          <PageMain
            ref="main"
            :tableData="tableData"
            :loading="loading"
            :tablePage="page"
            @reload="reload"
            @markTsk="markTskApi"
            @checkbox-change="(data) => (checkedRows = data)"
          >
            <PageHeader
              ref="header"
              slot="header"
              @query="getData"
              @reset="resetPage"
            >
              <el-badge :value="checkedRowCount" :hidden="!checkedRowCount">
                <b-button
                  size="sm"
                  class="ml-2"
                  variant="outline-primary"
                  :disabled="!checkedRowCount"
                  @click="markTsk()"
                >
                  <b-icon-star></b-icon-star>
                  {{ $l('btn_markTsk') || '重点标记' }}
                </b-button>
              </el-badge>
            </PageHeader>
            <pagination
              slot="pager"
              :current-page="page.curPage"
              :page-size="page.pageSize"
              :page-total="page.pageTotal"
              @change="handlePaginationChange"
            />
            <template #toolbar_btn>
              <SortFieldsPopover
                v-model="sortFields"
                funcListName="taskCenterList"
                style="margin-right: 0.8em"
                @change="getData"
              />
            </template>
          </PageMain>
        </el-card>
      </div>
    </div>

    <AddForm :visible.sync="addFormVisible" @reload="reload" />
  </div>
</template>
<script>
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
import PageMain from './main.vue'
import PageHeader from './header'
import PageFilter from './filter'
import AddForm from '../add-form'
import SortFieldsPopover from '@/views/digital/components/sort-fields-popover'
export default {
  mixins: [BaseTable, EditLoading],
  components: { PageMain, PageHeader, PageFilter, AddForm, SortFieldsPopover },
  data() {
    return {
      usePage: true,
      localTimeZone: '',
      addFormVisible: false,
      tskStatus: 'N',
      sortFields: [],
      checkedRows: [],
    }
  },
  computed: {
    checkedRowCount() {
      return this.checkedRows?.length || 0
    },
  },
  methods: {
    async loadLocalTimeZone() {
      return new Promise((resolve) => {
        if (this.localTimeZone) return resolve(this.localTimeZone)
        const now = new Date()
        const offsetMinutes = now.getTimezoneOffset()
        const offsetHours = Math.abs(Math.floor(offsetMinutes / 60))
        const offsetMinutesRemainder = Math.abs(offsetMinutes % 60)
        const offsetString = `${offsetMinutes >= 0 ? '-' : '+'}${offsetHours
          .toString()
          .padStart(2, '0')}:${offsetMinutesRemainder
          .toString()
          .padStart(2, '0')}`

        this.localTimeZone = offsetString
        resolve(offsetString)
      })
    },
    async getData(form) {
      this.loading = true
      const localTimeZone = await this.loadLocalTimeZone()
      const params = {
        ...form,
        ...this.page,
        localTimeZone,
        sortFields: this.sortFields,
      }

      this.$refs.filter.getData(params)
      const res = await this.getDataApi(params)
      this.loading = false
      if (!res) return
      this.setData(res)
    },
    getDataApi(params) {
      switch (this.tskStatus || '') {
        case 'timeout':
          return this.$api
            .personalTskInfoTimeoutListApi({ ...params })
            .catch(() => null)
        case 'schedule':
          return this.$api
            .personalTskInfoScheduleListApi({ ...params })
            .catch(() => null)
        case 'related':
          return this.$api
            .personalTskInfoRelatedListApi({ ...params })
            .catch(() => null)
        case 'marked':
          return this.$api
            .personalTskInfoMarkedListApi({ ...params })
            .catch(() => null)
        default:
          return this.$api
            .personalTskInfoCenterListApi({
              ...params,
              tskStatus: this.tskStatus,
            })
            .catch(() => null)
      }
    },
    markTsk() {
      if (!this.checkedRowCount) return
      const listTskInfoCode = this.checkedRows.map((row) => row.tskInfoCode)
      this.markTskApi(listTskInfoCode)
    },
    async markTskApi(listTskInfoCode) {
      const confirm = await this.$confirm(
        this.$l('tips_markTsk') || '是否确认重点标记选中的任务？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return

      const res = await this.$api
        .personalTskMarkAddApi({ listTskInfoCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('tips_markTsk_no') || '标记失败！')
        return
      }
      this.$message({
        message: this.$l('tips_markTsk_ok') || '标记成功！',
        type: 'success',
      })
      this.$refs.main.clearCheckboxRow()
      this.reload()
    },
    filterChange() {
      this.$refs.main.clearCheckboxRow()
      this.$refs.header.query()
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .el-card {
    border: none;
    .el-card__body {
      padding: 14px !important;
    }
  }
}
</style>
